import { Accordion, Container } from '@mantine/core';
import items from './UseCases.data.json';
import classes from './UseCases.module.css';
import { Wrapper } from './UseCases.style';

export type UseCasesProps = {};

export function UseCases(_props: UseCasesProps) {
  function renderItem(item: Json) {
    return (
      <Accordion.Item className={classes.item} value={item.id}>
        <Accordion.Control>{item.title}</Accordion.Control>
        <Accordion.Panel>{item.description}</Accordion.Panel>
      </Accordion.Item>
    );
  }

  function renderItems() {
    return (items as Json).map((item: IModel) => renderItem(item));
  }

  return (
    <Wrapper className='UseCases-wrapper' data-testid='UseCases-wrapper'>
      <Container size='sm' className={classes.wrapper}>
        <Accordion variant='separated'>{renderItems()}</Accordion>
      </Container>
    </Wrapper>
  );
}

export default UseCases;
